import React, { useCallback, useContext, useMemo } from "react";
import _ from "lodash";
import HeadingSection from "../UI/HeadingSection";
import UserContext from "../../context/user/UserContext";
import { Body } from "../UI/Text";
import { useTheme } from "styled-components";
import { Flex } from "reflexbox";

const View = ({ interactionId, currentInteraction, setShow }) => {
  const { activeUser } = useContext(UserContext);
  const theme = useTheme();

  const {
    site_ref,
    interaction_id,
    interaction_type,
    ref_num_id,
    ref_seq,
    description,
    interaction_date,
    follow_date,
    stat,
    topic,
    contact,
    phone,
    RefType,
    RefRowPointer,
    contact_id,
    slsman,
    NoteExistsFlag,
    RecordDate,
    RowPointer,
    CreatedBy,
    UpdatedBy,
    CreateDate,
    InWorkflow,
  } = currentInteraction || {};

  return (
    <>
      <HeadingSection
        my="1rem"
        hideCreate
        hideBack
        backButtonLink={() => setShow(false)}
        title={`${interactionId === "create" ? "Create" : "View"} Interaction`}
        subtitle=""
      />

      <Flex flexDirection={["column", "column", "row"]} style={{ gap: "1rem" }}>
        <Flex flexDirection="column">
          <Body>
            <span style={{ color: theme.secondary }}>Site Reference #:</span>{" "}
            {site_ref}
          </Body>
          <Body>
            <span style={{ color: theme.secondary }}>ID:</span> {interaction_id}
          </Body>
          <Body>
            <span style={{ color: theme.secondary }}>Type:</span>{" "}
            {interaction_type}
          </Body>
          <Body>
            <span style={{ color: theme.secondary }}>Reference #::</span>{" "}
            {ref_num_id}
          </Body>
          <Body>
            <span style={{ color: theme.secondary }}>Reference Seq:</span>{" "}
            {ref_seq}
          </Body>

          <Body>
            <span style={{ color: theme.secondary }}>Description:</span>{" "}
            {description}
          </Body>
          <Body>
            <span style={{ color: theme.secondary }}>Interaction Date:</span>{" "}
            {interaction_date}
          </Body>
          <Body>
            <span style={{ color: theme.secondary }}>Follow Date:</span>{" "}
            {follow_date}
          </Body>
          <Body>
            <span style={{ color: theme.secondary }}>Status:</span> {stat}
          </Body>
        </Flex>

        <Flex flexDirection="column">
          <Body>
            <span style={{ color: theme.secondary }}>Topic:</span> {topic}
          </Body>
          <Body>
            <span style={{ color: theme.secondary }}>Contact:</span> {contact}
          </Body>
          <Body>
            <span style={{ color: theme.secondary }}>Phone:</span> {phone}
          </Body>

          <Body>
            <span style={{ color: theme.secondary }}>Ref Type:</span> {RefType}
          </Body>
          {/* <Body>
            <span style={{ color: theme.secondary }}>Ref RowPointer:</span>{" "}
            {RefRowPointer}
          </Body> */}
          <Body>
            <span style={{ color: theme.secondary }}>contact_id:</span>{" "}
            {contact_id}
          </Body>
          {/* <Body>
            <span style={{ color: theme.secondary }}>slsman:</span> {slsman}
          </Body> */}
          {/* <Body>
            <span style={{ color: theme.secondary }}>NoteExistsFlag:</span>{" "}
            {NoteExistsFlag}
          </Body> */}
          <Body>
            <span style={{ color: theme.secondary }}>Record Date:</span>{" "}
            {RecordDate}
          </Body>

          {/* <Body>
            <span style={{ color: theme.secondary }}>RowPointer:</span>{" "}
            {RowPointer}
          </Body> */}
          <Body>
            <span style={{ color: theme.secondary }}>Created By:</span>{" "}
            {CreatedBy}
          </Body>
          <Body>
            <span style={{ color: theme.secondary }}>Updated By:</span>{" "}
            {UpdatedBy}
          </Body>
          <Body>
            <span style={{ color: theme.secondary }}>Created Date:</span>{" "}
            {CreateDate}
          </Body>
          {/* <Body>
            <span style={{ color: theme.secondary }}>InWorkflow:</span>{" "}
            {InWorkflow}
          </Body> */}
        </Flex>
      </Flex>
    </>
  );
};

export default View;
